import {Drawer, Grid, Menu} from "antd";
import type {ItemType} from "antd/es/menu/interface";
import {useLayoutStore} from "../stores/LayoutStore.ts";
import LogoRaiders from "./LogoRaiders.tsx";
import {MenuFoldOutlined} from "@ant-design/icons";
import {useThemeStore} from "../stores/ThemeStore.ts";

interface NavSiderProps {
  menuItems: ItemType[];
  selectedKey: string;
}

function NavSider({menuItems, selectedKey}: NavSiderProps) {
  const {useBreakpoint} = Grid;
  const screens = useBreakpoint();
  const {collapsed, toggleCollapsed} = useLayoutStore();
  const {getTheme} = useThemeStore();
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  const items: ItemType[] = menuItems.map((item) => ({
    ...item,
    onClick: (e) => {
      toggleCollapsed(true);
      e.domEvent.stopPropagation();
    },
  }));

  const color =
      getTheme() === "light" ? "rgba(223,189,152,0.9)" : "rgba(29,29,31,0.9)";

  return (
      <>
        {
            !screens.md && (
                <Drawer
                    title={<LogoRaiders/>}
                    placement={"left"}
                    closable={true}
                    closeIcon={
                      <MenuFoldOutlined className="navbar-user-icon text-2xl"/>
                    }
                    onClose={() => toggleCollapsed(true)}
                    open={!collapsed}
                    key={"left"}
                    style={{backgroundColor: color}}
                >
                  <Menu
                      mode="inline"
                      selectedKeys={[selectedKey]}
                      items={items}
                      className={"h-full bg-transparent!"}
                      style={{borderRight: 0}}
                  />
                </Drawer>
            )
          // <Sider width={240} breakpoint="md" collapsedWidth={0} style={{background: "transparent"}} collapsed={collapsed}>
          //   <Menu
          //       mode="inline"
          //       selectedKeys={[selectedKey]}
          //       items={items}
          //       className={"h-full"}
          //       style={{borderRight: 0}}
          //   />
          // </Sider>
        }
      </>
  );
}

export {NavSider};
